import {AuthGuard} from '../../shared/guards/AuthGuard';
import {AnalysisRequestPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const AnalysisRequestPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <AnalysisRequestPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};